import { DEFAULT_CIP_CHEMICALS } from "../../constants/global.constants";

export const CHEMICAL_FIELDS_CONFIG = {
  acid: {
    titleKey: "defaultInformationStrings.acid_cip_ph",
    chemicalLabelKey: "defaultInformationStrings.acidchemicalLabel",
    priceKey: "acidPrice",
    chemicalKey: "acid_chemical",
    defaultOption: DEFAULT_CIP_CHEMICALS.ACID.chem_id,
  },
  alkali: {
    titleKey: "defaultInformationStrings.alkali_cip_ph",
    chemicalLabelKey: "defaultInformationStrings.alkalichemicalLabel",
    priceKey: "alkaliPrice",
    chemicalKey: "alkali_chemical",
    defaultOption: DEFAULT_CIP_CHEMICALS.ALKALI.chem_id,
  },
  additional_chemical: {
    titleKey: "defaultInformationStrings.cip_solution_ph",
    chemicalLabelKey: "defaultInformationStrings.solutionChemicalLabel",
    priceKey: "additional_chemical_price",
    chemicalKey: "additional_chemical",
    defaultOption: DEFAULT_CIP_CHEMICALS.SOLUTION.chem_id,
  },
};

export const CHEMICAL_FIELDS_KEYS = Object.keys(CHEMICAL_FIELDS_CONFIG);
